<template>
  <div class="full-width">
    <v-hover>
      <v-carousel
        :key="dashboardAdvertisements.length"
        v-model="currentAdvertisementIndex"
        slot-scope="{hover}"
        :interval="currentAdvertisementInterval"
        :height="advertisementsMaxHeight"
        :hide-delimiters="$vuetify.breakpoint.xs || !hover"
        :hide-controls="dashboardAdvertisements.length <= 1 || !hover"
        class="elevation-0 custom-carousel-look clickable"
        :style="{
          'max-width': advertisementsMaxWidth + 'px',
        }"
      >
        <v-carousel-item
          v-for="advert in dashboardAdvertisements"
          :key="advert.id"
          @click.native="onAdvertClicked(advert)"
        >
          <div slot="default">
            <v-img
              :title="advert.title"
              :height="advertisementsMaxHeight"
              :src="
                $vuetify.breakpoint.xs
                  ? advert.image_mobile_url || advert.image_desktop_url
                  : advert.image_desktop_url || advert.image_mobile_url
              "
              contain
            />
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-hover>
    <v-dialog
      v-model="showConfirmationDialog"
      :persistent="!finalized"
      lazy
      :width="$store.state.common.mediumDialogWidth"
    >
      <v-card>
        <v-card-title
          v-if="clickedAdvert"
          class="pb-0 d-block"
        >
          <v-layout align-center>
            <v-layout
              align-center
              wrap
            >
              <div class="headline mb-2">
                {{ $t('dashboardAdvertSignalInterestTitlePrefix') }} "{{
                  clickedAdvert.title
                }}"
              </div>
            </v-layout>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              @click="closeAdvertDialog()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
          <img
            class="mt-2"
            :src="
              $vuetify.breakpoint.xs
                ? clickedAdvert.image_mobile_url ||
                  clickedAdvert.image_desktop_url
                : clickedAdvert.image_desktop_url ||
                  clickedAdvert.image_mobile_url
            "
            style="max-width: 100%; max-height: 240px"
          >
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-if="!finalized"
            ref="messageinput"
            v-model="message"
            :label="$t('dashboardAdvertSignalInterestMessagePlaceholder')"
            :placeholder="$t('dashboardAdvertSignalInterestMessageDefault')"
            rows="4"
            auto-grow
          />
          <v-layout
            v-else
            class="mt-3"
            align-center
            style="font-size: larger"
          >
            <v-icon
              color="success"
              medium
              class="mr-2"
            >
              check
            </v-icon>
            {{ $t('dashboardAdvertSignalInterestSubmitted') }}
          </v-layout>
        </v-card-text>
        <v-card-actions v-if="!finalized">
          <v-btn
            round
            flat
            color="msr"
            class="ml-auto"
            :loading="busy"
            @click="submit()"
          >
            {{ $t('dashboardAdvertSignalInterestSubmit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentAdvertisementIndex: null,

      // Confirmation dialog
      clickedAdvert: null,
      showConfirmationDialog: false,
      message: '',
      busy: false,
      finalized: false,
    };
  },
  computed: {
    /**
     * For now we rely on the parent context to fetch this list from the API.
     *
     * Note: The :key on the carousel based on this list changing is
     *   important, so any newly calculated interval for the initial
     *   advert is correctly applied.
     */
    dashboardAdvertisements() {
      return this.$store.state.common.dashboardAdvertisements;
    },
    currentAdvertisement() {
      if (
        this.currentAdvertisementIndex == null ||
        this.dashboardAdvertisements.length == 0
      ) {
        return null;
      }
      return this.dashboardAdvertisements[this.currentAdvertisementIndex];
    },
    currentAdvertisementInterval() {
      // Duration is in seconds, interval needs to be in milliseconds.
      if (this.currentAdvertisement) {
        return this.currentAdvertisement.duration * 1000;
      }
      return 20000; // Fallback to 20s.
    },
    advertisementsMaxHeight() {
      return this.$vuetify.breakpoint.xs ? 160 : 320;
    },
    advertisementsMaxWidth() {
      if (!this.currentAdvertisement) {
        return 1090;
      }
      if (
        this.$vuetify.breakpoint.xs &&
        this.currentAdvertisement.image_mobile_url
      ) {
        return this.currentAdvertisement.image_mobile_width;
      }
      return this.currentAdvertisement.image_desktop_width;
    },
    probablyInAppWrapper() {
      return (
        this.$store.state.common.runtimeEnv.android ||
        this.$store.state.common.runtimeEnv.iOS
      );
    },
  },
  methods: {
    onAdvertClicked(advert) {
      if (this.probablyInAppWrapper && !!advert.mobile_link_url) {
        // Open optional URL on mobile phones, e.g. to redirect to WhatsApp.
        window.open(advert.mobile_link_url, '_blank');
      } else {
        this.openAdvertDialog(advert);
      }
    },
    openAdvertDialog(advert) {
      this.clickedAdvert = advert;
      this.showConfirmationDialog = true;
      this.finalized = false;
      this.message = '';

      this.$nextTick(() => {
        this.$refs.messageinput.focus();
      });
    },
    closeAdvertDialog() {
      this.clickedAdvert = null;
      this.showConfirmationDialog = false;
    },
    finalizeAdvertDialog() {
      this.finalized = true;
    },
    submit() {
      this.busy = true;
      this.$api
        .signalInterestForDashboardAdvertisement(
          this.clickedAdvert.id,
          this.message
        )
        .then(() => {
          this.busy = false;
          this.finalizeAdvertDialog();
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DashboardAdvertisementsCarousel.vue